import api from "@/api";

const namespaced = true;

const state = {
  vesselManagement: [],
  vesselManagementFiles: {}
}

const getters = {
  vesselManagement: state => state.vesselManagement,
  vesselManagementFiles: state => state.vesselManagementFiles
}

const mutations = {
  SET_VESSEL_MANAGEMENT: (state, payload) => {
    state.vesselManagement = payload;
  },
  SET_VESSEL_MANAGEMENT_FILES: (state, payload) => {
    state.vesselManagementFiles = payload;
  }
}

const actions = {
  async fetchVesselManagement({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        ...payload
      }
      const { data } = await api.getVesselManagements(params)
      if (data.error) {
        commit('SET_VESSEL_MANAGEMENT', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_VESSEL_MANAGEMENT', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (error) {
      throw error;
    }
  },
  async postVesselManagement({}, payload) {
    try {
      await api.postVesselManagement(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async putVesselManagement({}, payload) {
    try {
      await api.putVesselManagement(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteVesselManagement({}, payload) {
    try {
      await api.deleteVesselManagement(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async getVesselCheckExist({}, payload) {
    try {
      const { data } = await api.getVesselCheckExist(payload.id, payload.params)
      return data
    } catch (error) {
      throw error
    }
  },
  async downloadVesselManagement({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getVesselManagementExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_VESSEL_MANAGEMENT_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetVesselManagementFiles({ commit }) {
    commit('SET_VESSEL_MANAGEMENT_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }